"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRejectRemovalRequestMutation = exports.useApproveRemovalRequestMutation = exports.useListRemovalRequestsQuery = exports.useCreateRemovalRequestMutation = exports.changeEventRemovalRequestApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.changeEventRemovalRequestApi = (0, react_1.createApi)({
    reducerPath: "changeEventRemovalRequestApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["removal-requests"],
    endpoints: function (builder) { return ({
        createRemovalRequest: builder.mutation({
            query: function (body) { return ({
                url: "/v1/change-event-removal-requests/create",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["removal-requests"],
        }),
        listRemovalRequests: builder.query({
            query: function (args) { return ({
                url: "/v1/change-event-removal-requests/all",
                method: "GET",
                params: __assign(__assign(__assign(__assign({ clientId: args.clientId }, (args.status ? { status: args.status } : {})), (args.entityType ? { entityType: args.entityType } : {})), (args.entityId ? { entityId: args.entityId } : {})), (args.eventId ? { eventId: args.eventId } : {})),
            }); },
            providesTags: ["removal-requests"],
        }),
        approveRemovalRequest: builder.mutation({
            query: function (body) { return ({
                url: "/v1/change-event-removal-requests/approve",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["removal-requests"],
        }),
        rejectRemovalRequest: builder.mutation({
            query: function (body) { return ({
                url: "/v1/change-event-removal-requests/reject",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["removal-requests"],
        }),
    }); },
});
exports.useCreateRemovalRequestMutation = exports.changeEventRemovalRequestApi.useCreateRemovalRequestMutation, exports.useListRemovalRequestsQuery = exports.changeEventRemovalRequestApi.useListRemovalRequestsQuery, exports.useApproveRemovalRequestMutation = exports.changeEventRemovalRequestApi.useApproveRemovalRequestMutation, exports.useRejectRemovalRequestMutation = exports.changeEventRemovalRequestApi.useRejectRemovalRequestMutation;
